import axios from 'axios';

const axiosInstance = axios.create({
  baseURL: `${process.env.VUE_APP_AUTH_API}/api`,
});

export default axiosInstance;
